import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';

import { UsuarioService } from './usuarios.service';
import { Usuario } from './../usuario/usuario';

import { GrupoService } from './../grupos/grupo.service';
import { Grupo } from './../grupos/grupo';

import { PerfilService } from './../perfis/perfil.service';
import { Perfil } from './../perfis/perfil';

import { PER_PAGE } from './../constante';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css'],
  providers: [UsuarioService, GrupoService, PerfilService]
})

export class UsuariosComponent  implements OnInit {
  titulo: string = "Usuarios";
  public usuarios: Usuario[];
  public grupos: Grupo[];
  public perfils: Perfil[];
  public params:any = {nome: undefined, grupo:undefined, perfil:undefined};
  public busy: Promise<any>;
  public paginaAtual: number = 1;
  public itensPorPagina: number = 1;
  public totalItens: number = 1;

  getUsuarios(): void {
    this.params['page'] = this.paginaAtual;
    this.busy = this.usuarioService.getUsuarios(this.params)
      .then(usuarios => this.carregar(usuarios));
  }

  carregar(usuarios: any): void{
    this.usuarios = usuarios.data;
    this.paginaAtual = usuarios.current_page;
    this.totalItens = usuarios.total;
    this.itensPorPagina = usuarios.per_page;
  }

  getGrupos(): void{
    this.grupoService.getAllGrupos()
        .then((response) => this.grupos = response);
  }

  getPerfis(): void{
    this.perfilService.getPerfis()
        .then((response) => this.perfils = response);
  }

  pageChanged(page: any): void{
    this.paginaAtual = page;
    this.getUsuarios();
  }

  constructor( private usuarioService: UsuarioService, private grupoService: GrupoService, private perfilService: PerfilService ) {

  }

  ngOnInit() {
    this.getUsuarios();
    this.getGrupos();
    this.getPerfis();
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarios/usuarios.component.ts